import type { DemoKey } from '../types';

export const ur: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'ریاضی · شماریات',
  'app.title': 'شماریات',
  'panel.experiment': 'منظر',
  'panel.params': 'پیرامیٹرز',

  'exp.survey-explorer.title': 'سروے ایکسپلورر',
  'exp.survey-explorer.desc': 'ایک کالم چنیں؛ ڈیمو مناسب خلاصہ خود چن لیتا ہے۔',
  'exp.distribution-sculptor.title': 'تقسیم کا مجسمہ ساز',
  'exp.distribution-sculptor.desc': 'نقاط کھینچیں اور دیکھیں کہ شماریات کیسے رد عمل کرتی ہیں۔',
  'exp.two-variable-lab.title': 'دو متغیر لیب',
  'exp.two-variable-lab.desc': 'بکھرے نقشے، فِٹ، اور سببیت کا سوال۔',
  'exp.sampling-lab.title': 'نمونہ گیری لیب',
  'exp.sampling-lab.desc': 'طریقہ اور سائز نمونے کے اوسط کو کیسے بدلتے ہیں۔',
  'exp.probability-diagrams.title': 'امکانی نقشے',
  'exp.probability-diagrams.desc': 'مرکب واقعات کے وین اور درختی منظر۔',

  'type.qualitative-nominal.label': 'معیاری · ناموی',
  'type.qualitative-nominal.def': 'بغیر ترتیب کے زمرے۔',
  'type.qualitative-ordinal.label': 'معیاری · ترتیبی',
  'type.qualitative-ordinal.def': 'بامعنی ترتیب والے زمرے۔',
  'type.qualitative-multi.label': 'معیاری · کثیر قدر',
  'type.qualitative-multi.def': 'ہر مشاہدے پر کئی ٹیگ ہو سکتے ہیں۔',
  'type.quantitative-discrete.label': 'مقداری · مفصول',
  'type.quantitative-discrete.def': 'مقررہ مراحل میں نمبر۔',
  'type.quantitative-continuous.label': 'مقداری · مسلسل',
  'type.quantitative-continuous.def': 'مسلسل پیمانے پر مقیّد نمبر۔',

  'column.name.label': 'طالب علم کا نام',
  'column.height_cm.label': 'قد',
  'column.shoe_size_eu.label': 'جوتے کا سائز (EU)',
  'column.study_hours.label': 'مطالعہ کے گھنٹے / ہفتہ',
  'column.test_score.label': 'ٹیسٹ کے نمبر',
  'column.sports_played.label': 'کھیلے گئے کھیل',
  'column.eye_color.label': 'آنکھ کا رنگ',
  'column.commute_min.label': 'سفر',
  'column.grade_year.label': 'جماعت',
  'column.homework_effort.label': 'ہوم ورک محنت',
  'column.ice-cream-sales.label': 'آئس کریم کی فروخت',
  'column.drownings.label': 'ڈوبنے کے واقعات',
  'column.month.label': 'مہینہ',
  'column.storks.label': 'لقلق',
  'column.births.label': 'پیدائش',
  'column.country_area_km2.label': 'ملک کا رقبہ',
  'column.sleep_hours.label': 'نیند کے گھنٹے',
  'column.reaction_ms.label': 'ردِعمل وقت',

  'dataset.master-survey.label': 'کلاس سروے',
  'dataset.master-survey.desc': '۳۰ مصنوعی طلبہ۔',
  'dataset.spurious-ice-cream-vs-drownings.label': 'آئس کریم فروخت بمقابلہ ڈوبنا',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'دونوں موسم کے ساتھ اوپر نیچے ہوتے ہیں۔ ڈوبنا آئس کریم کی وجہ نہیں۔',
  'dataset.spurious-storks-vs-births.label': 'لقلق بمقابلہ پیدائش',
  'dataset.spurious-storks-vs-births.desc':
    'بڑے ممالک میں زیادہ لقلق اور زیادہ پیدائش۔ پرندے وجہ نہیں۔',
  'dataset.real-sleep-vs-reaction-time.label': 'نیند بمقابلہ ردِعمل',
  'dataset.real-sleep-vs-reaction-time.desc':
    'زیادہ نیند، تیز ردِعمل۔ ایک حقیقی منفی تعلق — اور قابلِ یقین وجہ۔',

  'tag.football.label': 'فٹبال',
  'tag.basketball.label': 'باسکٹ بال',
  'tag.volleyball.label': 'والی بال',
  'tag.swimming.label': 'تیراکی',
  'tag.none.label': 'کوئی نہیں',

  'population.gaussian.label': 'گھنٹی کا منحنی',
  'population.right-skewed.label': 'دائیں جانب جھکا',
  'population.bimodal.label': 'دو چوٹی (طبقات کے ساتھ)',
  'population.uniform.label': 'یکساں',

  'venn.dice-even-or-prime.label': 'پانسہ: جفت یا اولیہ',
  'venn.class-sports-2set.label': 'کھیل (۲ سیٹ)',
  'venn.class-sports-3set.label': 'کھیل (۳ سیٹ)',
  'venn.custom.label': 'حسبِ ضرورت',

  'tree.draw-without-replacement.label': 'بغیر واپسی کے',
  'tree.custom.label': 'حسبِ ضرورت',
  'tree.coin.heads': 'سر',
  'tree.coin.tails': 'پٹ',
  'tree.draw.start': 'تھیلا: ۲ سرخ، ۳ نیلی',
  'tree.draw.red': 'سرخ',
  'tree.draw.blue': 'نیلا',
  'tree.custom.start': 'شروع',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'ہسٹوگرام',
  'card.cumulative': 'مجموعی تکرار',
  'card.box': 'باکس پلاٹ',
  'card.summary': '۵ اعداد خلاصہ',
  'card.bar': 'بار چارٹ',
  'card.mode': 'مَوڈ',
  'card.tag-frequency': 'ٹیگ تکرار',
  'card.mode-tag': 'سب سے زیادہ ٹیگ',
  'card.empty-no-order': 'غیر منطبق',
  'card.empty-multi': 'غیر منطبق',
  'card.numberline': 'عددی خط',
  'card.scatter': 'بکھراؤ',
  'card.description': 'کیا ہو رہا ہے',
  'card.population': 'آبادی',
  'card.sampling-distribution': 'نمونوں کے اوسط',
  'card.venn': 'وین',
  'card.tree': 'درخت',
  'card.probabilities': 'امکانات',

  'param.dataset.label': 'ڈیٹا سیٹ',
  'param.column.label': 'کالم',
  'param.bins.label': 'بنز',
  'param.shape.label': 'ابتدائی شکل',
  'param.show-mean.label': 'اوسط دکھائیں',
  'param.show-median.label': 'وسطانیہ دکھائیں',
  'param.x-col.label': 'X کالم',
  'param.y-col.label': 'Y کالم',
  'param.show-regression.label': 'رجعت لائن',
  'param.show-residuals.label': 'بقایا',
  'param.show-confounder.label': 'الجھنے والا دکھائیں',
  'param.population.label': 'آبادی',
  'param.technique.label': 'طریقہ',
  'param.sample-size.label': 'نمونہ سائز',
  'param.stratum.label': 'طبقہ',
  'param.bias.label': 'تعصب',
  'param.mode.label': 'موڈ',
  'param.preset.label': 'پری سیٹ',
  'param.universe.label': 'کائنات کا سائز',
  'param.show-prob.label': 'امکانات دکھائیں',
  'param.treat-as-numeric.label': 'عددی سمجھیں',

  'stat.count': 'تعداد',
  'stat.mean': 'اوسط',
  'stat.median': 'وسطانیہ',
  'stat.range': 'مدی',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'مستثنیات',
  'stat.r': 'پیئرسن r',
  'stat.r2': 'r²',
  'stat.slope': 'ڈھلوان',
  'stat.intercept': 'انٹرسیپٹ',
  'stat.n': 'n',
  'stat.population-mean': 'حقیقی اوسط',
  'stat.latest-sample-mean': 'نمونہ اوسط',
  'stat.sample-mean-spread': 'نمونہ اوسط-SD',
  'stat.sample-count': 'لیے گئے نمونے',
  'outlier.upper': 'بالائی مستثنیات',
  'outlier.lower': 'زیریں مستثنیات',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'دوبارہ نمونہ',
  'btn.run-100': '۱۰۰ نمونے لیں',
  'btn.stop': 'روکیں',
  'btn.clear-history': 'تاریخ صاف کریں',

  'explainer.no-order': 'ترتیب نہیں → نہ مجموعی، نہ باکس۔',
  'explainer.multi-no-iqr': 'کثیر قدر → چوتھائیاں / IQR متعین نہیں۔',
  'message.no-data': 'کوئی ڈیٹا نہیں۔',
  'message.needs-quartiles': 'چوتھائیوں کے لیے ≥۴ نقاط چاہیئے۔',
  'message.x-zero-variance': 'X کا فرق صفر — کوئی لائن فِٹ نہیں۔',
  'message.n-too-small': 'n بہت چھوٹا۔',
  'message.stratum-clamp': 'طبقے میں مطلوبہ سے کم قطاریں — سب استعمال ہوئیں۔',
  'message.siblings-sum-to-one': 'بہن بھائیوں کا مجموع ۱ ہونا چاہیے۔',
};
